module.exports = __webpack_public_path__ + "static/media/mobile.f9b20338.svg";